import { render, staticRenderFns } from "./InstructionFilePreview.vue?vue&type=template&id=4a9842c0"
import script from "./InstructionFilePreview.vue?vue&type=script&lang=ts"
export * from "./InstructionFilePreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports